import React from 'react';

import PropTypes from 'prop-types';

import './ErrorBanner.sass';

export const ErrorBanner = ({ children }) => {
  if (children) {
    return <div className="error-banner">{children}</div>;
  }
  return null;
};
ErrorBanner.propTypes = {
  children: PropTypes.string.isRequired,
};
